import {
  Alignment,
  Button,
  Classes,
  Dialog,
  HTMLSelect,
  InputGroup,
  Switch,
} from "@blueprintjs/core";
import { DateInput } from "@blueprintjs/datetime";
import { observable } from "mobx";
import { observer } from "mobx-react";
import * as React from "react";
import { ICalc, IContestacaoCalc, IContestacaoLote, IEmpresa, IMva, IProduto } from "../../model";
import { AppStore } from "../../stores/AppStore";
import { CalcStore } from "../../stores/calculo/CalcStore";
import { ResultadoStore } from "../../stores/resultados/ResultadoStore";
import { getMomentFormatter } from "../../utils";
import { FormGroup } from "@blueprintjs/core";
import MomentLocaleUtils from "react-day-picker/moment";
import { CalcRSStore } from "../../stores/calculo-rs/CalcRSStore";
import { toast } from "react-toastify";
import { GenerateCalcOptions } from "./calcs_options";
import { CalcSelect, filterCalcs, renderCalcs } from "../utils/CalcSelect";
import InfoModal from "../info-modal/InfoModal";
import { AppIcon } from "../utils/AppIcon";
import { Autocomplete, CircularProgress, TextField } from "@mui/material";

var debounce = require('lodash.debounce');

interface ContestarLoteDialogProps {
  items: IContestacaoCalc[];
  tipo: string;
  empresaSelecionada: IEmpresa;
  modelo: string;
  onClose: (reload?: boolean) => void;
}

interface ContestarLoteDialogState {
  loading: boolean
}

@observer
export class ContestarLoteDialog
  extends React.Component<ContestarLoteDialogProps, ContestarLoteDialogState> {

  obs = observable({
    contestacao: {} as IContestacaoLote,
    info_calculo: {} as ICalc,
    contestarAll: false as boolean,
    alertContestarAll: false as boolean,
    memoria_salvar: false as boolean,
    retroativas: true as boolean,
    aplicar_retencao: false as boolean,
    alterar_data: false as boolean,
    isDevolucao: false,
    calc_selecionado: null,
    calc_devolucao_selecionado: null,
    cnpj_memoria: true as boolean,
    open_ajuda: false as boolean,

    mudar_mva: false as boolean,
    mva_selected: null as IMva,
    loading: false as boolean,
    filter: "" as string,
    page: 1 as number,
    hasMore: true as boolean,
    options: [] as IMva[],
    fetchOptions: {} as any
  })

  constructor(props: any) {
    super(props);

    this.obs.fetchOptions = debounce(this.fetchOptions.bind(this), 800);

    this.state = {
      loading: false
    }

  }

  async componentDidMount(): Promise<void> {

    if (ResultadoStore.obs.empresaContestar.uf == "RS") {

      await CalcRSStore.load();

    } else {

      await CalcStore.load();

    }

    this.obs.contestacao = observable({
      nota_item_ids: this.props.items?.map(value => value["id"]),
      motivo: "",
      contestacao_calc_id: null,
      contestacao_data: null,
      entrada_saida: this.props.tipo.toLocaleLowerCase(),
      modelo: this.props.modelo.toLowerCase(),
    });

    this.fetchOptions("", 1);

  }

  handleValid() {

    if (this.obs.alterar_data) {

      if (!this.obs.contestacao.contestacao_data) {
        return true
      }

    } else {

      if (!this.obs.calc_selecionado) {
        return true
      }

    }

    if (!this.obs.contestacao.motivo) {
      return true
    }

    return false

  }

  handleContestarData(e) {
    this.obs.alterar_data = e

    this.obs.contestacao.contestacao_calc_id = null
    this.obs.contestacao.contestacao_calc_id_devolucao = null
    this.obs.contestacao.contestacao_produto_id = null

    this.obs.calc_devolucao_selecionado = null
    this.obs.calc_selecionado = null

    this.obs.memoria_salvar = false
    this.obs.cnpj_memoria = false
    this.obs.aplicar_retencao = false
  }

  handleConfirm = async () => {

    try {

      if (this.obs.mudar_mva) {

        if (!this.obs.mva_selected) {
          toast.warning('Por favor, selecione um produto.', {});
          ResultadoStore.obs.working = false
          return;
        }

        if (!window.confirm("Você está selecionando um produto diferente do informado na nota. O MVA aplicado será referente ao produto selecionado.")) {
          ResultadoStore.obs.working = false
          return
        }

        this.obs.contestacao.contestacao_produto_id = this.obs.mva_selected.id

      } else {

        this.obs.contestacao.contestacao_produto_id = null

      }

      ResultadoStore.obs.working = true
      ResultadoStore.obs.ids_contestacao_all = []
      ResultadoStore.obs.itemsAllCount = 1

      if (ResultadoStore.obs.contestar_todos && !ResultadoStore.obs.notasRetroativas && !ResultadoStore.obs.notasDivergentes && !ResultadoStore.obs.notasManual) {
        this.obs.contestacao.nota_item_ids = []
        this.obs.contestacao.entrada_saida = ""

        await ResultadoStore.query_all_itens_pages(
          this.props.empresaSelecionada,
          [ResultadoStore.obs.date_start, ResultadoStore.obs.date_end],
          ResultadoStore.obs.icmsClassFilter,
          this.props.tipo,
          this.props.modelo,
          ResultadoStore.obs.filters
        )

        this.obs.contestacao.nota_item_ids = [...ResultadoStore.obs.ids_contestacao_all]

        if (!window.confirm("Você está prestes a contestar " + this.obs.contestacao.nota_item_ids.length + " itens." + "\nObs: Itens que já estão em processo são ignorados!")) {
          ResultadoStore.obs.working = false
          this.props.onClose()
          return
        }

        this.obs.contestacao.nota_item_ids?.map((el, index) => {
          this.obs.contestacao.entrada_saida = this.props.tipo.toLowerCase()
        })
        ResultadoStore.obs.ids_contestacao_all = []
        ResultadoStore.obs.itemsAllCount = 1
      }

      let devolucao = false

      if (this.obs.aplicar_retencao) {

        if (!this.obs.calc_devolucao_selecionado._id) {
          toast.warning('Por favor, selecione um cálculo para a retenção.', {});
          ResultadoStore.obs.working = false
          return;
        }

        this.obs.contestacao.contestacao_calc_id_devolucao = this.obs.calc_devolucao_selecionado._id
        this.obs.contestacao.contestacao_calc_id = this.obs.alterar_data ? null : this.obs.calc_selecionado._id

        devolucao = true

      } else {

        delete this.obs.contestacao.contestacao_calc_id_devolucao
        this.obs.contestacao.contestacao_calc_id = this.obs.alterar_data ? null : this.obs.calc_selecionado._id

        devolucao = false

      }

      await ResultadoStore.create_contestacao_task(this.obs.contestacao, this.obs.memoria_salvar, ResultadoStore.obs.empresaContestar.uf, devolucao, ResultadoStore.obs.empresaContestar.cnpj, ResultadoStore.obs.date_start, ResultadoStore.obs.date_end, this.obs.cnpj_memoria)

      ResultadoStore.consulta_resultados_calculo()

      this.props.onClose();

    } catch (e) { ResultadoStore.obs.working = false }

  };

  handleValidDevolucao() {

    let calcOptions: any = []

    if (ResultadoStore.obs.empresaContestar.uf == "RS") {

      calcOptions = CalcRSStore.validForDate()?.find(obj => obj._id == this.obs.calc_selecionado._id)

      this.obs.isDevolucao = calcOptions?.devolucao ? calcOptions.devolucao : false

    } else {

      calcOptions = CalcStore.validForDate()?.find(obj => obj._id == this.obs.calc_selecionado._id)

      this.obs.isDevolucao = calcOptions?.devolucao ? calcOptions.devolucao : false

    }

  }

  handleSelect = (event: any, item: IMva | null) => {

    this.obs.mva_selected = item

  };

  handleScroll = (event: any) => {

    const bottom = event.target.scrollHeight - event.target.scrollTop === event.target.clientHeight;

    if (bottom && this.obs.hasMore) {

      this.fetchOptions(this.obs.filter, this.obs.page + 1);

    }

  };

  async fetchOptions(inputValue: string, page: number) {

    this.setState({ loading: true })

    try {

      this.obs.filter = inputValue

      let result = await ResultadoStore.handleMvas(page, inputValue, this.props.tipo, ResultadoStore.obs.empresaContestar.uf);

      if (result.length > 0) {

        this.obs.options = [...this.obs.options, ...result];
        this.obs.page = page;
        this.obs.hasMore = true

      } else {

        this.obs.hasMore = false;

      }

    } catch (error) { }

    this.setState({ loading: false })

  }

  render() {
    let tmp_tipo = this.props.tipo.toLowerCase().replace("í", "i");
    let tmp_modelo = this.props.modelo.toLowerCase().replace("-", "");

    let calcOptions: any = []
    let calcOptionsRetro: any = []
    let calcOptionsRetencao: any = []

    let dayPickerProps = {
      localeUtils: MomentLocaleUtils,
      locale: "pt-br",
    };

    if (this.props.items.length > 0) {

      if (ResultadoStore.obs.empresaContestar.uf == "RS") {

        calcOptions = GenerateCalcOptions(CalcRSStore.validForDate(), tmp_tipo, tmp_modelo, ResultadoStore.obs.empresaContestar)
        calcOptionsRetro = GenerateCalcOptions(CalcRSStore.validForDateRetro(), tmp_tipo, tmp_modelo, ResultadoStore.obs.empresaContestar)

      } else {

        calcOptions = GenerateCalcOptions(CalcStore.validForDate(), tmp_tipo, tmp_modelo, ResultadoStore.obs.empresaContestar)
        calcOptionsRetro = GenerateCalcOptions(CalcStore.validForDateRetro(), tmp_tipo, tmp_modelo, ResultadoStore.obs.empresaContestar)

      }

    }

    calcOptionsRetencao = CalcStore.validForDate()?.map((calc: ICalc) => {

      if (calc["saida"] == true && calc[tmp_modelo] == true) {

        return calc

      }

      return null

    }).filter(option => option !== null);

    let calcText = !this.obs.calc_selecionado?.nome ? "Selecione o Cálculo" : `${this.obs.calc_selecionado.nome.length >= 100 ? this.obs.calc_selecionado.nome.substring(0, 100) + "..." : this.obs.calc_selecionado.nome}`
    let devolucaoText = !this.obs.calc_devolucao_selecionado?.nome ? "Selecione o Cálculo" : `${this.obs.calc_devolucao_selecionado.nome.length >= 120 ? this.obs.calc_devolucao_selecionado.nome.substring(0, 120) + "..." : this.obs.calc_devolucao_selecionado.nome}`

    return (
      <>
        <Dialog
          isOpen={true}
          onClose={() => this.props.onClose()}
          className="modal-contestacao"
        >
          <div className={Classes.DIALOG_HEADER}>
            <div style={{ display: "flex", width: "100%" }}>
              <h2 className="title-no-bottom">Contestar Cálculo</h2>
              {this.obs.isDevolucao && tmp_tipo.toLocaleLowerCase() == "entrada" && AppStore.obs1.selectedEmpresa.simples_nacional && (tmp_modelo.toLowerCase() == "nfe" || tmp_modelo.toLowerCase() == "nfce") &&
                <Switch
                  label={"Aplicar retenção na saída?"}
                  checked={this.obs.aplicar_retencao}
                  onChange={(e: any) => this.obs.aplicar_retencao = e.target.checked}
                  style={{ marginTop: 12, marginLeft: "auto", fontSize: 12, fontWeight: 600 }}
                />
              }
            </div>
          </div>
          <div className={Classes.DIALOG_BODY}>
            {!this.obs.alterar_data ? (
              <div className="contestar-form">
                <div className="contestar-row">
                  <FormGroup
                    label={<>Utilizar cálculo <span className="contestar-required">*</span></>}
                    className="empresaSelect calcSelect contestar-field-grow"
                  >
                    <CalcSelect
                      items={this.obs.retroativas ? calcOptions : calcOptionsRetro}
                      itemRenderer={renderCalcs}
                      itemPredicate={filterCalcs}
                      onItemSelect={(e: ICalc) => {
                        this.obs.calc_selecionado = e
                        this.handleValidDevolucao()
                      }}
                      inputProps={{ placeholder: "Filtrar um Cálculo" }}
                      matchTargetWidth
                    >
                      <Button text={calcText} rightIcon="double-caret-vertical" alignText={Alignment.LEFT} />
                    </CalcSelect>
                  </FormGroup>
                  <FormGroup label={"\u200B"} style={{ width: 152 }}>
                    <Switch
                      label={this.obs.retroativas ? "Cálculo Vigentes" : "Cálculos Retroativos"}
                      checked={this.obs.retroativas}
                      onChange={(e: any) => this.obs.retroativas = e.target.checked}
                      style={{ marginBottom: 0, marginTop: 14, flexShrink: 0 }}
                    />
                  </FormGroup>
                </div>

                {this.obs.aplicar_retencao && (
                  <div className="contestar-row">
                    <FormGroup label={<>Cálculo da retenção <span className="contestar-required">*</span></>} className="empresaSelect calcSelect contestar-field-grow">
                      <CalcSelect
                        items={calcOptionsRetencao}
                        itemRenderer={renderCalcs}
                        itemPredicate={filterCalcs}
                        onItemSelect={(e: ICalc) => this.obs.calc_devolucao_selecionado = e}
                        inputProps={{ placeholder: "Filtrar um Cálculo" }}
                        matchTargetWidth
                      >
                        <Button text={devolucaoText} rightIcon="double-caret-vertical" alignText={Alignment.LEFT} />
                      </CalcSelect>
                    </FormGroup>
                  </div>
                )}

                <div className="contestar-row">
                  {this.obs.mudar_mva ? (
                    <>
                      <FormGroup
                        label={<>Utilizar Produto <span className="contestar-required">*</span></>}
                        className="contestar-field-grow"
                      >
                        <Autocomplete
                          disablePortal
                          size="small"
                          options={this.obs.options}
                          onInputChange={(event, value) => {
                            this.obs.options = [];
                            this.obs.page = 1;
                            this.obs.hasMore = true;
                            this.obs.fetchOptions(value, 1);
                          }}
                          getOptionLabel={(option) => `${option.produto_ncm} - ${option.produto_cest} - ${option.produto_desc}` || ""}
                          filterOptions={(x) => x}
                          onChange={this.handleSelect}
                          ListboxProps={{ onScroll: this.handleScroll }}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              placeholder="Selecione o Produto"
                              variant="outlined"
                              InputProps={{
                                ...params.InputProps,
                                endAdornment: (
                                  <>
                                    {this.state.loading ? <CircularProgress color="inherit" size={20} /> : null}
                                    {params.InputProps.endAdornment}
                                  </>
                                ),
                              }}
                            />
                          )}
                          value={this.obs.mva_selected}
                          className='select-empresas'
                          clearOnBlur
                          clearOnEscape
                          blurOnSelect
                          noOptionsText="Não foram encontrados resultados!"
                        />
                      </FormGroup>
                      <FormGroup label={"\u200B"} style={{ width: 152 }}>
                        <Switch
                          label="Mudando produto"
                          checked={this.obs.mudar_mva}
                          onChange={(e: any) => this.obs.mudar_mva = e.target.checked}
                          style={{ marginBottom: 0, marginTop: 14 }}
                        />
                      </FormGroup>
                    </>
                  ) : (
                    <FormGroup label="Mudar MVA">
                      <Switch
                        innerLabelChecked="Sim"
                        innerLabel="Não"
                        checked={this.obs.mudar_mva}
                        onChange={(e: any) => this.obs.mudar_mva = e.target.checked}
                        style={{ marginBottom: 0 }}
                      />
                    </FormGroup>
                  )}
                </div>

                <div className="contestar-row">
                  <FormGroup label="Alterar data" style={{ flex: "0 0 180px" }}>
                    <DateInput
                      {...getMomentFormatter("DD/MM/YYYY")}
                      locale="pt-br"
                      dayPickerProps={dayPickerProps}
                      value={this.obs.contestacao.contestacao_data ? new Date(this.obs.contestacao.contestacao_data) : null}
                      onChange={val => this.obs.contestacao.contestacao_data = val}
                      placeholder="DD/MM/AAAA"
                      canClearSelection
                    />
                  </FormGroup>
                  <FormGroup label={<>Motivo <span className="contestar-required">*</span></>} className="contestar-field-grow">
                    <InputGroup
                      value={this.obs.contestacao.motivo}
                      onChange={(e: any) => this.obs.contestacao.motivo = e.target.value}
                    />
                  </FormGroup>
                </div>
              </div>
            ) : (
              <div className="contestar-form">
                <div className="contestar-row">
                  <FormGroup label={<>Alterar data <span className="contestar-required">*</span></>} style={{ flex: "0 0 180px" }}>
                    <DateInput
                      {...getMomentFormatter("DD/MM/YYYY")}
                      locale="pt-br"
                      dayPickerProps={dayPickerProps}
                      value={this.obs.contestacao.contestacao_data ? new Date(this.obs.contestacao.contestacao_data) : null}
                      onChange={val => this.obs.contestacao.contestacao_data = val}
                      placeholder="DD/MM/AAAA"
                      canClearSelection
                    />
                  </FormGroup>
                  <FormGroup label={<>Motivo <span className="contestar-required">*</span></>} className="contestar-field-grow">
                    <InputGroup
                      value={this.obs.contestacao.motivo}
                      onChange={(e: any) => this.obs.contestacao.motivo = e.target.value}
                    />
                  </FormGroup>
                </div>
              </div>
            )}

            <div className="contestar-footer">
              <div className="contestar-switches">
                <div style={{ display: "flex", alignItems: "center" }}>
                  <label style={{ width: 140, marginBottom: 0 }}>
                    Salvar contestação
                    {this.obs.memoria_salvar  && <AppIcon
                      name="help"
                      className="pulse-notification-pgdas"
                      color="blue"
                      style={{ cursor: "pointer", marginLeft: 5 }}
                      onClick={(e) => ResultadoStore.obs.open_ajuda_salvar = true}
                    />}
                  </label>
                  <Switch
                    alignIndicator={Alignment.RIGHT}
                    innerLabelChecked="Sim"
                    innerLabel="Não"
                    disabled={this.obs.alterar_data}
                    checked={this.obs.memoria_salvar}
                    onChange={(e: any) => this.obs.memoria_salvar = e.target.checked}
                  />
                </div>
                <Switch
                  label="Apenas data"
                  alignIndicator={Alignment.RIGHT}
                  innerLabelChecked="Sim"
                  innerLabel="Não"
                  onChange={(e: any) => this.handleContestarData(e.target.checked)}
                  style={{ paddingTop: 10 }}
                />
                {this.obs.memoria_salvar && (
                  <div style={{ display: "flex", alignItems: "center", paddingTop: 10 }}>
                    <label style={{ width: 140, marginBottom: 0 }}>
                      Memória CNPJ
                      <AppIcon
                        name="help"
                        className="pulse-notification-pgdas"
                        color="blue"
                        style={{ cursor: "pointer", marginLeft: 5 }}
                        onClick={() => this.obs.open_ajuda = true}
                      />
                    </label>
                    <Switch
                      alignIndicator={Alignment.RIGHT}
                      innerLabelChecked="Sim"
                      innerLabel="Não"
                      disabled={this.obs.alterar_data}
                      checked={this.obs.cnpj_memoria}
                      onChange={(e: any) => this.obs.cnpj_memoria = e.target.checked}
                    />
                  </div>
                )}
              </div>

              <div className="contestar-actions">
                <Button text="Cancelar" onClick={() => this.props.onClose()} />
                <Button
                  text="Contestar"
                  intent="primary"
                  onClick={this.handleConfirm}
                  loading={ResultadoStore.obs.working}
                  disabled={this.handleValid()}
                />
              </div>
            </div>
          </div>
        </Dialog >

        <InfoModal open={this.obs.open_ajuda} onClose={() => this.obs.open_ajuda = false} texto_info={`

          <b>Memória CNPJ:</b><br /><br />

          <b>Ativada</b> – O sistema valida o CNPJ de origem nas entradas e o CNPJ de destino nas saídas para salvar a Memória de Cálculo.<br /><br />

          <b>Desativada</b> – O sistema não realiza a validação de CNPJ, permitindo salvar a Memória de Cálculo sem informações de CNPJ.<br /><br />

        `} />

      </>
    );
  }
}
